import { StageFilter } from "./filters/StageFilter";
import { RegionFilter } from "./filters/RegionFilter";
import { TeamSizeFilter } from "./filters/TeamSizeFilter";
import { ProFilter } from "./filters/ProFilter";

interface StartupFiltersProps {
  filters: {
    stage: string[];
    continent: string[];
    teamSize: string[];
    isPro: boolean | null;
    category: string[];
  };
  onFilterChange: (key: string, value: any) => void;
}

export function StartupFilters({ filters, onFilterChange }: StartupFiltersProps) {
  return (
    <div className="flex flex-col w-full gap-2 lg:flex-row lg:w-auto">
      <StageFilter
        selectedStages={filters.stage}
        onStageChange={(stages) => onFilterChange("stage", stages)}
      />
      <RegionFilter
        selectedRegions={filters.continent}
        onRegionChange={(regions) => onFilterChange("continent", regions)}
      />
      <TeamSizeFilter
        selectedSizes={filters.teamSize}
        onTeamSizeChange={(sizes) => onFilterChange("teamSize", sizes)}
      />
      <ProFilter
        isPro={filters.isPro}
        onProChange={(isPro) => onFilterChange("isPro", isPro)}
      />
    </div>
  );
}